module.exports = __webpack_public_path__ + "media/images/brand/app_symbol_400-37856ca9a25a04e809c56d9bfea0c100.png";